import { createGlobalStyle } from "styled-components";


const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    transition: all 0.25s linear;
  }
`;




export default GlobalStyle;
